exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FixedSizeImage__image___ZRx_y {\n\twidth: 4rem;\n\theight: 4rem;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tflex-shrink: 0;\n}\n\n.FixedSizeImage__cover___3pTa4 {\n\tbackground-size: cover;\n}\n", ""]);

// exports
exports.locals = {
	"image": "FixedSizeImage__image___ZRx_y",
	"cover": "FixedSizeImage__cover___3pTa4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/FixedSizeImage.icss
// module id = 1449
// module chunks = 0